<template>
  <div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']">
    <div class="header_container">
      <div class="logo">
        <img src="../assets/image/logo.png" alt />
      </div>
      <div class="centerBtn"></div>
      <div class="rightBtn">
        <div class="myGiftBtn" @click="$router.go(-1)">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/backBtn.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/backBtn.png" alt />
        </div>
      </div>
      <div class="rightIcon"></div>
    </div>
    <div class="ruleTitle">
      <van-row class="m_b">
        <van-col span="24" class="c_w m_b5 t_ac f_25">活动规则</van-col>
      </van-row>
      <van-row class="m_b5">
        <van-col span="24" class="c_w m_b5 t_ac f_20" >
          <!-- <div class="onlyLine">
            <img src="../assets/image/onlyLine.png">
          </div> -->
          <div class="onlyLine02">
            <img src="../assets/image/onlyLine.png" alt />
          </div>
        </van-col>
      </van-row>
      <!-- <van-row class="m_b10">
        <div class="timeModule_Box">
           <van-col span="6" class="c_w m_b5" >
          <div class="leftBtn">活动时间</div>
        </van-col>
        <van-col span="18" class="c_w m_b5" >
          <div class="rightTime">
            <div>2020年1月13日-2020年2月20日，</div>
            <div>10:00-22:00</div>
          </div>
        </van-col>
        </div>
      </van-row> -->
      <!-- <van-row>
        <van-col span="10" class="c_w m_b5" >
          <div class="leftBtn">活动规则与奖品</div>
        </van-col>
      </van-row> -->
      <van-row style="margin-bottom: 40px;">
        <van-col span="24" class="c_w m_b5 f_12 lh22">
          <div v-html="actInfo.ruleDescription"></div>
          <!-- <div>
            活动期间在网上订餐渠道（官方网站、官方微信、官方APP）任意消费后，
            即可在“我的订单”参与抽奖（需完成下单且达美乐账户绑定手机号后才可参与抽奖），
            官方微信小程序下单也可至官方网站/官方微信/官方APP的“我的订单”参与抽奖，抽奖手机号需与达美乐账户绑定手机号一致，
            详情请咨询4001-597-597、各达美乐门店或官网及抽奖活动页说明。人人有礼！
          </div> -->
          <!-- <div style="margin-top: 20px;">
            <div>一等奖：999足金金钞（共200份）；</div>
            <div>二等奖：半价12”红薯薯泥卷边香甜双虾菠萝比萨1个（共15,000个）；</div>
            <div>三等奖：原价购买任意比萨送9”经典手拍美国风情土豆培根比萨1个（共20,000个）；</div>
            <div>四等奖：原价购买任意比萨送意大利风情肉酱面1份（共25,000份）；</div>
            <div>五等奖：原价购买任意比萨送藤椒风味嫩香鸡腿1份（共30,000份）；</div>
            <div>六等奖：原价购买任意比萨送热狗面包卷1份（人人有礼，若未获得1-5等奖的参与者均可得）。</div>
          </div> -->

          <!-- <div style="margin-top: 20px;">
            1个订单仅可抽奖1次，如取消订单所得奖品也随之取消。
            本次抽奖涉及订单及抽奖行为需在2020年2月20日前完成，若在截止时间内未完成，视为主动放弃抽奖资格，且无法保留抽奖资格至下一档抽奖活动。
            2-6等奖的奖品会以电子券的形式放入获奖者绑定手机号对应的达美乐账户【我的卡券】中，电子券自发放之日起30天内有效，
            在达美乐官方网站、官方微信、官方APP消费时使用。一等奖获奖者需在抽奖H5页面填写姓名、地址、电话信息，奖品会在活动结束后的2周内快递给获奖者。
            1-5等奖抽完即止，中奖率为实际抽出奖项个数与参与抽奖人数之比，未获得1-5等奖的参与者均可得6等奖。不与其他优惠同享。
            每笔订单最多可以使用两张优惠券。产品及包装以实物为准，图片仅供参考，器皿不在售卖范围内。
            不同城市或不同餐厅的供应菜单和价格有所不同，详情以输入收餐地址后显示的实际供应菜单和价格为准。
          </div> -->
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      actInfo: {},
      isNewSkin: false, // 是否新皮肤
    };
  },
  computed: {
    userInfo02: function() {
      return this.$store.getters.getInfo02;
    }
  },
  methods: {
    async getDetail() {
      if (!this.userInfo02) {
        return Toast("无法获取活动信息");
      }
      const toastLoading = Toast.loading({
        message: "正在加载",
        forbidClick: true,
        duration: 0
      });
      let id = this.userInfo02.luckActId;
      try {
        // let {data: result} = await this.$get(`/consumer/mkt-activity/get/${id}`);
        let {data: result} = await this.$get(`/consumer/mkt-activity/getByCache/${id}`);
        if (result.code !== 200) {
          Toast(result.errMsg);
          toastLoading.clear();
        }
        this.actInfo = result.data;
        toastLoading.clear();
      } catch(err) {
        console.log(err);
      }
    }
  },
  created() {
    this.getDetail();

    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
  },
  beforeCreate() {
    document.title = "抽奖";
  }
};
</script>

<style lang="scss" scoped>
/deep/.van-cell {
  width: 100%;
  height: 100%;
  background-color: #dcf6ff;
  line-height: 35px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.home_container {
  width: 100%;
  padding-top: 20px;
  // background-image: url("../assets/image/bgc01.png");
  background-size: 100% 100%;
  .header_container {
    width: 100%;
    height: 50px;
    display: flex;
    .logo {
      flex: 3;
      padding-left: 15px;
      img {
        width: 100%;
      }
    }
    .centerBtn {
      flex: 2;
      padding-left: 10px;
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightIcon {
      width: 30px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .ruleTitle {
    width: 100%;
    min-height: 200px;
    padding: 0px 20px;
    .onlyLine {
      width: 100%;
      height: 10px;
      img {
        width:60%;
        margin-bottom: 7px;
      }
    }
    .onlyLine02 {
      width: 100%;
      height: 20px;
      margin: 0 auto;
      // background-color: rgba(255, 255, 255, .5);
      img {
        width: 60%;
        // margin-bottom: 7px;
      }
}
    .leftBtn {
      width: 100%;
      height: 35px;
      border: 1px solid #FFF;
      text-align: center;
      line-height: 35px;
      border-radius: 20px;
      font-size: 16px;
    }
    .rightTime {
      padding-left: 15px;
      height: 35px;
      line-height: 20px;
      font-size: 14px;
    }
  }
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}

.timeModule_Box {
  height: 40px;
  width: 100%;
}
</style>
